module.exports = __webpack_public_path__ + "9c7d25649337c3b39d5ce32b8de41842.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/LV.svg
// module id = kIly
// module chunks = 0